module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmEU9fBxc4EsA.665639f6.woff2";